import { render } from "./ExcelRibbonComponent.vue?vue&type=template&id=35ee2de6"
import script from "./ExcelRibbonComponent.vue?vue&type=script&lang=js"
export * from "./ExcelRibbonComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__